import PropTypes from 'prop-types';
import React from 'react';

//

const MotionContext = React.createContext();

//

function MotionContextProvider({ children, variants }) {
  return <MotionContext.Provider value={{ variants }}>{children}</MotionContext.Provider>;
}

MotionContextProvider.propTypes = {
  children: PropTypes.any,
  variants: PropTypes.object.isRequired,
};

// Exports
// -------

export { MotionContext, MotionContextProvider };

export default MotionContext;
